import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import ServiceInclude from "../../component/ServiceInclude";


const Managed = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Salesforce Managed Service Consultant</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=" "
                />
                <meta
                    name="keywords"
                    content=" "
                />
            </Helmet>
            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Managed Services</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/managed.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">Salesforce Managed Services is a proactive approach to managing and supporting organizations using Salesforce CRM seamlessly. Many businesses lack the expertise or resources to continuously evaluate and optimize their CRM, implement enhancements, and keep it updated with new releases. Salesforce Managed Services address this gap by offering a comprehensive set of activities, from consulting and implementation to providing expert resources and block hours. The goal is to prevent issues before they impact business operations.</p>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>What is the process followed by Codezix as a Salesforce Support company for providing Salesforce support services?</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezixoffers a comprehensive range of Salesforce professional services to enhance your CRM strategy with the right software solution.</p>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Savvy-arrangements.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Savvy arrangements</h3>
                                            <p className="wow fadeUp prose-lg">We provide a complete range of Salesforce solutions to help you eliminate the additional costs associated with hiring multiple resources.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/On-request%20Adaptable%20arrangements.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> On-request Adaptable arrangements</h3>
                                            <p className="wow fadeUp prose-lg"> Before starting work on your requirements, our Salesforce specialists take the time to understand your business model, processes, and needs. This ensures that whenever you need a Salesforce solution, we can provide you with the best solutions promptly.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Key%20Decision%20Making2.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Key Decision Making</h3>
                                            <p className="wow fadeUp prose-lg"> To develop and expand your business, you need to make significant and relevant decisions regarding your current CRM system. Our Salesforce specialists will help you devise the best strategic plans that perfectly align with your business requirements. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Proactive%20Salesforce%20specialists%20for%20your%20help.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Proactive Salesforce specialists for your help</h3>
                                            <p className="wow fadeUp prose-lg"> By partnering with us, you'll gain access to a fully dedicated team of Salesforce managed service providers with in-depth expertise in Salesforce. They will assist you with bug fixes, integration issues, and help you implement new features and the latest updates. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Increase%20your%20Return%20on%20Investment%20(ROI)3.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Increase your Return on Investment (ROI)</h3>
                                            <p className="wow fadeUp prose-lg"> As a trusted Salesforce partner, we ensure that your integrated Salesforce system functions properly, meets your goals, contributes to efficient business operations, and enhances your return on investment. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>What are the key activities Codezix follows as a Salesforce Managed Service Partner?</h2>
                                <p className="wow fadeUp prose-lg text-left"> Key activities followed by Salesforce Managed Service Partner are</p>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Consulting</h3>
                                        <p className="wow fadeUp prose-lg">
                                            This includes business and process analysis to develop a long-term strategy for Salesforce utilization.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/managed/partner-1.webp')} alt='' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Implementation </h3>
                                        <p className="wow fadeUp prose-lg">
                                            Service providers deliver various Salesforce Clouds and applications to build new capabilities within your Salesforce environment.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/managed/partner-2.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Customization </h3>
                                        <p className="wow fadeUp prose-lg">
                                            This includes the creation of customized dashboards, reports, campaign setups, and more.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/managed/partner-3.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Integration</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Your Salesforce environment is integrated with third-party systems such as ERPs, accounting packages, e-commerce solutions, and more, helping you create a connected ecosystem.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/managed/partner-4.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Data Management</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Setting up the framework for data collection and flow based on your specific requirements.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/managed/partner-5.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Training</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Service providers conduct training sessions to provide technical guidance on best practices for using the Salesforce platform.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/managed/partner-6.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Support</h3>
                                        <p className="wow fadeUp prose-lg">
                                            This includes system checks, bug fixes, and issue resolution as they arise over time.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/managed/partner-7.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>What does Codezix offer you as a Salesforce Managed Services Consultant?</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezix, as a Salesforce Managed Services Consultant, offers a comprehensive range of Salesforce Managed Services backed by our thorough strategies.</p>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-1.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Vital preparation</h3>
                                            <p className="wow fadeUp prose-lg"> From establishing boundaries to optimizing operations, we work closely with your organization, fully immersing ourselves in understanding your vision.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-2.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Salesforce administrator </h3>
                                            <p className="wow fadeUp prose-lg"> You’ll have skilled and experienced tech specialists available to you at all times. Rest assured, we have all the resources and tools you need to handle every task efficiently.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-3.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Salesforce advancement</h3>
                                            <p className="wow fadeUp prose-lg">Not only do we address your solution and development-related issues, but we also enhance your operations by offering up-to-date and effective recommendations. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-4.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Upgrades</h3>
                                            <p className="wow fadeUp prose-lg"> We ensure that you don’t have to worry about security and handle your updates regularly, so your operations run smoothly and are always up to date.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-5.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Coordination Backing</h3>
                                            <p className="wow fadeUp prose-lg"> We assist in achieving your goals by handling integration monitoring, troubleshooting, custom API integrations, and more, ensuring your team has all the necessary data at their fingertips.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-6.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Investigation reports and dashboards</h3>
                                            <p className="wow fadeUp prose-lg">If you need access to reports, dashboards, and metrics that matter most to you, we provide a comprehensive view of your business. This helps you gain a deeper understanding of both your business and your customers. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-7.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Training</h3>
                                            <p className="wow fadeUp prose-lg"> We can help train your entire team on the Salesforce platform, including administrators, end-users, and managers.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-8.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Data migration</h3>
                                            <p className="wow fadeUp prose-lg"> Avoid the mistake of neglecting to clean your data. Without accurate and timely data when you need it, business processes can fail. We ensure seamless integration, reporting, validation, MDM, and more.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src={require('../../assets/images/salesforce/managed/managed-9.webp')} alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Lightning migration</h3>
                                            <p className="wow fadeUp prose-lg"> You can trust us to manage the complex process of transitioning from Classic to Lightning. We'll ensure that you're always on the right path throughout the process.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>What products does Codezix offer as a Salesforce Managed Services Company?</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezix, as a Salesforce Managed Services Company, offers a comprehensive range of Salesforce products to help you manage all your business activities effectively, ensuring seamless operations and enhanced productivity.</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/customization#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </>
    )
}

export default Managed;